import './sentry';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PostHogProvider } from 'posthog-js/react';
import '_services/i18n';
import posthog from '_services/posthog';

import reportWebVitals from './reportWebVitals';
import App from './App';
import './main.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error("Root container not found. Ensure there is an element with id='root' in your HTML.");
}

const root = createRoot(container);

const isProduction = import.meta.env.MODE === 'production';
const posthogApiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const posthogApiHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

const app = (
  <StrictMode>
    {isProduction && posthogApiKey && posthogApiHost ? (
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </StrictMode>
);

root.render(app);

if (!isProduction) {
  reportWebVitals(console.log);
}